import { categoryReducer as categoriesReducer } from "./reducer";

export default categoriesReducer;
